/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_ResettingInputs */

const zh_auth_resetting = /** @type {(inputs: Auth_ResettingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重置中...`)
};

const en_auth_resetting = /** @type {(inputs: Auth_ResettingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resetting...`)
};

const es_auth_resetting = /** @type {(inputs: Auth_ResettingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restableciendo...`)
};

/**
* | output |
* | --- |
* | "Resetting..." |
*
* @param {Auth_ResettingInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_resetting = /** @type {((inputs?: Auth_ResettingInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_ResettingInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_resetting(inputs)
	if (locale === "en") return en_auth_resetting(inputs)
	return es_auth_resetting(inputs)
});